import {backAdmin} from "../axios";

export const rolesApi = [
    {url: `${backAdmin}/roles`, name: 'roles.all', method: 'GET'},
    {url: `${backAdmin}/roles/permissions`, name: 'roles.permissions', method: 'GET'},
    {url: `${backAdmin}/roles/role`, name: 'roles.create', method: 'POST'},
    {url: `${backAdmin}/roles/{slug}`, name: 'roles.bySlug', method: 'GET'},
    {url: `${backAdmin}/roles/{id}`, name: 'roles.edit', method: 'PUT'},
]